import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "Données personnelles collectées",
    content: `Lorsque vous visitez le site, nous recueillons automatiquement certaines informations :`,
    list: [
      "Type de navigateur",
      "Adresse IP",
      "Fuseau horaire",
      "Cookies installés sur votre appareil",
      "Pages consultées, interactions avec le site",
    ],
    extra:
      "De plus, nous collectons les données que vous nous fournissez via les formulaires de contact ou de réservation : nom, prénom, adresse, téléphone, e-mail, informations de paiement, etc.",
  },
  {
    title: "Pourquoi traitons-nous vos données ?",
    content:
      "Nous traitons uniquement les données strictement nécessaires pour :",
    list: [
      "Assurer le bon fonctionnement du site",
      "Répondre à vos demandes ou messages",
      "Gérer les réservations et contrats de service",
      "Protéger nos intérêts légitimes (sécurité, prévention des abus)",
    ],
    extra:
      "Note : Ces données ne sont ni revendues ni utilisées à d'autres fins commerciales.",
  },
  {
    title: "Vos droits",
    content:
      "Si vous êtes résident de l'Union européenne, vous disposez des droits suivants :",
    list: [
      "Droit d'accès, de rectification et d'effacement",
      "Droit à la limitation du traitement et d'opposition",
      "Droit à la portabilité des données",
      "Droit de retirer votre consentement à tout moment",
    ],
    extra: "Pour exercer ces droits, contactez-nous à : warnervtc@gmail.com",
  },
  {
    title: "Sécurité des données",
    content:
      "Vos informations sont stockées sur des serveurs sécurisés. Des mesures techniques et organisationnelles sont mises en œuvre pour limiter tout accès non autorisé, perte ou divulgation. Cependant, aucune transmission via Internet n'est totalement sécurisée. L'utilisation du site reste donc à vos propres risques.",
  },
  {
    title: "Liens externes",
    content:
      "Notre site peut contenir des liens vers d'autres sites. Nous ne sommes pas responsables des pratiques de confidentialité de ces sites tiers. Nous vous invitons à consulter leur propre politique de confidentialité.",
  },
  {
    title: "Divulgation légale",
    content:
      "Nous pourrons divulguer vos données si la loi l'exige (ex. : procédure judiciaire, demande des autorités, prévention des fraudes ou atteinte à la sécurité).",
  },
  {
    title: "Contact",
    content:
      "Pour toute question relative à cette politique de confidentialité ou à vos données personnelles : warnervtc@gmail.com",
  },
];

export default function PrivacyPolicy() {
  return (
    <div
      data-testid="privacy-policy-page"
      className="min-h-screen bg-[#050505] pt-28 pb-24"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        {/* Back link */}
        <a
          href="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-gold/60 text-xs uppercase tracking-[0.2em] hover:text-gold transition-colors duration-300 mb-16"
        >
          <ArrowLeft size={14} strokeWidth={1.2} />
          Retour à l'accueil
        </a>

        {/* Header */}
        <div className="mb-16">
          <p className="font-accent italic text-gold text-base tracking-widest mb-4">
            Mentions légales
          </p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight mb-6">
            Politique de Confidentialité
          </h1>
          <div className="gold-line w-16 mb-8" />
          <p className="text-white/50 text-sm leading-[1.9] font-light tracking-wide">
            Le site web WARNER VTC est détenu et exploité par WARNER VTC,
            représenté par M. Erwan CALVEZ, qui agit en tant que responsable du
            traitement de vos données personnelles. Nous avons mis en place la
            présente politique de confidentialité afin d'expliquer comment nous
            collectons, utilisons et protégeons vos données personnelles.
          </p>
        </div>

        {/* Sections */}
        <div className="flex flex-col gap-14">
          {SECTIONS.map((section, idx) => (
            <div
              key={idx}
              data-testid={`privacy-section-${idx}`}
              className="relative"
            >
              {/* Gold corner */}
              <div className="absolute -left-4 top-0 w-4 h-4 border-l border-t border-gold/20 hidden lg:block" />

              <h2 className="font-display text-xl text-white mb-4 tracking-tight">
                {section.title}
              </h2>

              {section.content && (
                <p className="text-white/40 text-sm leading-[1.9] font-light tracking-wide mb-4">
                  {section.content}
                </p>
              )}

              {section.list && (
                <ul className="flex flex-col gap-2 mb-4 pl-4">
                  {section.list.map((item, i) => (
                    <li
                      key={i}
                      className="text-white/40 text-sm leading-relaxed font-light tracking-wide relative pl-4 before:content-[''] before:absolute before:left-0 before:top-[10px] before:w-1.5 before:h-px before:bg-gold/40"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              )}

              {section.extra && (
                <p className="text-white/35 text-sm leading-[1.9] font-light tracking-wide italic">
                  {section.extra}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
